import {
    onUpdateRecipients,
    initializeRecentAttachmentPillsView,
    deleteRecentAttachmentPillsView,
} from '../actions/internalActions';
import getRecentAttachmentsPillsData from '../selectors/getRecentAttachmentsPillsData';
import { createLazyOrchestrator } from 'owa-bundling';
import { onUpdateRecipientsInCompose } from '../actions/publicActions';
import { logUsage } from 'owa-analytics';
import { DP_RECENT_ATTACHMENT_PILLS_INITIALIZE } from '../constants';

export const onUpdateRecipientsInComposeOrchestrator = createLazyOrchestrator(
    onUpdateRecipientsInCompose,
    'onUpdate_Recipients_In_Compose',
    actionMessage => {
        const recentAttachmentsPillsData = getRecentAttachmentsPillsData(actionMessage.composeId);
        // Initialize when there is no data
        if (!recentAttachmentsPillsData && actionMessage.numberOfRecipients !== 0) {
            logUsage(DP_RECENT_ATTACHMENT_PILLS_INITIALIZE, {
                numberOfAttachments: actionMessage.attachments.length,
            });
            initializeRecentAttachmentPillsView(
                actionMessage.numberOfRecipients,
                actionMessage.recipientName,
                actionMessage.composeId,
                actionMessage.attachments
            );
            // Remove the control when there are no new recipients and the control is shown
            // When the control is not shown, it means the user intentially close it- so we don't want to display it again
            // when new recipients will be added
        } else if (
            actionMessage.numberOfRecipients === 0 &&
            recentAttachmentsPillsData?.displayPills
        ) {
            deleteRecentAttachmentPillsView(actionMessage.composeId);
            // Update the relevant values, when recipient added / removed .
        } else {
            onUpdateRecipients(
                actionMessage.composeId,
                actionMessage.numberOfRecipients,
                actionMessage.recipientName
            );
        }
    }
);
